module.exports = __webpack_public_path__ + "static/media/certification.3fcb5449.svg";